import { useEffect, useState } from 'react';
import { isSidebarCollapsed, onSidebarCollapsed } from '@utils/sidebarCollapsed';

/** Whether the left sidebar is closed, following it as it opens and closes. */
export const useSidebarCollapsed = () => {
  const [collapsed, setCollapsed] = useState(isSidebarCollapsed);
  useEffect(() => onSidebarCollapsed(setCollapsed), []);
  return collapsed;
};
